import axios from 'axios'
import qs from 'qs'
const DEFAULTCONTENTTYPE = 'application/json'
let apiUrl=window.config.api.gateway.general;

const service = axios.create({
  timeout: 50000
})
service.interceptors.request.use(
  config => {
    if (config.method.toLocaleLowerCase() === 'post') {
      config.headers['Content-Type'] =
        config.headers['Content-Type'] || DEFAULTCONTENTTYPE
      if (
        config.data &&
        config.headers['Content-Type'] ==
          'application/x-www-form-urlencoded; charset=UTF-8'
      ) {
        config.data = qs.stringify(config.data)
      }
    }
    return config
  },
  error => {
    console.log(error)
    const res = {
      code: 404,
      msg: '请求超时'
    }
    Message.error('请求出错！')
    return Promise.reject(res)
  }
)

service.interceptors.response.use(
  response => {
    let data
    if (response.data == undefined) {
      data = JSON.parse(response.request.responseText)
    } else if(response.data.type=='application/octet-stream')
    {
      return response
    }
    else {
      data = response.data
    }
    // 请求成功，直接回调data内容
    if (data.body.desc == "successful") {
      return data.body.content
    }
  },
  error => {
    const res = {
      code: 400,
      msg: error.message || '服务器错误',
      data: error.response
    }
    Message.error(res.msg)
    return Promise.reject(res)
  }
)

export default service
